import { render, staticRenderFns } from "./Foro.vue?vue&type=template&id=c148474a&scoped=true"
import script from "./Foro.vue?vue&type=script&lang=js"
export * from "./Foro.vue?vue&type=script&lang=js"
import style0 from "./Foro.vue?vue&type=style&index=0&id=c148474a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c148474a",
  null
  
)

export default component.exports